/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router';
import {Link,Prompt} from 'react-router-dom';
import guardDirtyState from 'react-router-guard-dirty-state';
import PropTypes from 'prop-types';
import BookNavigationPanel from './BookContainerComponents/BookNavigationPanel';
import AccessCodeSetupLink from "./AccessCodeSetupLink";
import VitalSourceAccessCodeSetupLink from "./VitalSourceAccessCodeSetupLink";
import BookDetailsLink from './BookDetailsLink';
import BookComponentTableLink from './BookComponentLink';
import OrderDetailsLink from './OrderDetailsLink';
import PdfLink from "./BookContainerComponents/PdfLink";
import ETextSetupLink from "./ETextSetupLink";
import VitalSourceSetupLink from "./VitalSourceSetupLink";
import ProductOfferDetailsLink from "./ProductOfferDetailsLink";
import AlertBox from "../../widgets/Alert/AlertBox";
import {PCSLogComponent} from "./PCSLogComponent";
import Moment from "moment/moment";
import EllipsisText  from 'react-ellipsis-text';
import {getSessionStorage} from '../../../_helpers/localStorage.helper';
import {PERMISSIONS} from '../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../_helpers/UserPermissionSingleton';
import CourseDetailsLink from "./CourseDetailsLink";

class BookContainer extends Component {
    static defaultProps = {
        guardDirtyIsActive: false
    };

    constructor(props) {
        super(props);

        this.state = {
            currentComponent: ""
        };

        this.sendToPCS = this.sendToPCS.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.setFormDirty = this.setFormDirty.bind(this);
        this.setActiveComponent = this.setActiveComponent.bind(this);
    }

    static get propTypes() {
        return {
            activeCollection: PropTypes.object.isRequired,
            getCollectionFromId: PropTypes.func.isRequired,
            getOrderDetails: PropTypes.func.isRequired,
            resetCollection: PropTypes.func.isRequired,
            getPCSLogs: PropTypes.func.isRequired,
            getPdfsByCollectionId: PropTypes.func.isRequired,
            router: PropTypes.object,
            title: PropTypes.string,
            sendToPCS: PropTypes.func.isRequired,
            guardDirtySetActive: PropTypes.func,
            guardDirtyIsActive: PropTypes.bool,
            children: PropTypes.node,
            getAccessCodeInfo: PropTypes.func.isRequired,
            saveAccessCodeSetup: PropTypes.func.isRequired,
            saveBookDetailsInfo: PropTypes.func.isRequired,
            rebuildBookSetup: PropTypes.func.isRequired,
            pdfLinks: PropTypes.object.isRequired,
            getBookBuildContent: PropTypes.func.isRequired,
            bookBuildContent:PropTypes.object.isRequired,
            clearBuildStatus:PropTypes.func.isRequired,
            getEtextStatuses: PropTypes.func.isRequired,
            etextStatuses: PropTypes.object.isRequired,
            vitalsourceStatuses: PropTypes.object.isRequired,
            saveOrderDetails: PropTypes.func.isRequired,
            saveEtextSetup: PropTypes.func.isRequired,
            updateProductDetails:PropTypes.func.isRequired,
            pcsLogs: PropTypes.array,
            setResourceStatus: PropTypes.func.isRequired,
            orderDetails: PropTypes.object.isRequired,
            updateOfferDetails:PropTypes.func.isRequired,
        };
    }

    setFormDirty (isDirty = false) {
        if (typeof this.props.guardDirtySetActive === 'function') {
            this.props.guardDirtySetActive(isDirty);
        }
    }

    componentWillMount() {
        this.props.getCollectionFromId(this.props.match.params.collId);
        this.props.getPCSLogs(this.props.match.params.collId);
        this.props.getAccessCodeInfo(this.props.match.params.collId);
        this.props.getEtextStatuses(this.props.match.params.collId);
    }
 
    componentDidMount(){
        this.props.getBookBuildContent(this.props.match.params.collId); 
    }

    componentWillUnmount() {
        //* Resets the collection when leaving the page
        this.props.resetCollection();
    }

    componentWillReceiveProps(nextProps){
        if(this.props.activeCollection.collectionId !== nextProps.activeCollection.collectionId){
            //Call Order Details
            this.props.getOrderDetails(nextProps.activeCollection.collectionId, nextProps.activeCollection.creator);
        }

        if(this.props.activeCollection.resourceIds && this.props.activeCollection.resourceIds !== nextProps.activeCollection.resourceIds){
            let count = 0;
            nextProps.activeCollection.chapters.forEach(chap => {
                chap.resourceInstances.forEach(res => {
                    if(res.sharing === "Private"){
                        count ++;
                    }
                });
            });

            if(count === 0){
                this.props.setResourceStatus(false);
            }else if (count > 0) {
                this.props.setResourceStatus(true);
            }
        }

    }


    sendToPCS(){
        this.props.sendToPCS(this.props.match.params.collId);
    }

    rebuildBook = () => {
        this.props.rebuildBookSetup(this.props.match.params.collId);
        this.props.getBookBuildContent(this.props.activeCollection.collectionId);
        this.props.clearBuildStatus();
        this.props.history.push('/digital-book/'+ this.props.match.params.collId +'/book-details');
    };

    sendToEtext = () =>{
        const {bookBuildContent} = this.props;
        const {collectionCourseInformation} = this.props.activeCollection;
        const {contact} =this.props.orderDetails;
        const isCourseNameSize = collectionCourseInformation.courseTitle;
        const isInstructorFirstName = contact.instructor.firstName;
        const isInstructorLastName= contact.instructor.lastName;
        const isIntitutionName = contact.institutionName;
        const isCourseNo = collectionCourseInformation.courseNo;
        const endDate = Date.parse(collectionCourseInformation.classEnd);
        const currentDate = Date.parse(new Date());
        if ((isCourseNameSize !== undefined && isCourseNameSize.length < 4 ) 
            || (isCourseNameSize !== undefined && isCourseNameSize.length > 50 )) {
            return alert('Course name must be between 4 to 50 characters');
        }
        if (( isInstructorFirstName === undefined ||  isInstructorFirstName === '' ) 
            || (isInstructorLastName === undefined || isInstructorLastName === '' )){
            return alert('Instructor name is required');
        }
        if (isIntitutionName === undefined || isIntitutionName === ''){
            return alert('Institution name is required');
        }
        if (endDate < currentDate){
            return alert('Course end date should be greater than current date');
        }
        if(isCourseNo !== '' || isCourseNo !== undefined ){
            const isCourseNo = collectionCourseInformation.courseNo;
            const re = /[!@#$%^&*(),.?":{}|<>]/;
            if (re.test(isCourseNo)){
                return alert ('Special characters are not allowed for course number');
            }
        }
        this.props.publishToEtext(this.props.match.params.collId, bookBuildContent.productDeliveryType);
    };

    sendToVitalsource = () =>{
        const {bookBuildContent} = this.props;
        this.props.publishToVitalsource(this.props.match.params.collId, bookBuildContent.productDeliveryType);
    };

    saveChanges(){
        if(this.state.currentComponent == 'BookDetails'){
            this.props.saveBookDetailsInfo(this.props.match.params.collId);
        }
        else if(this.state.currentComponent == 'AccessCodeSetup'){
            this.props.saveAccessCodeSetup(this.props.match.params.collId);
        }
        else if(this.state.currentComponent == 'OrderDetails'){
            this.props.saveOrderDetails(this.props.match.params.collId);
        }
        else if(this.state.currentComponent == 'EtextSetup'){
            this.props.saveEtextSetup(this.props.match.params.collId);
        }
        else if(this.state.currentComponent == 'VitalSourceSetup'){
            this.props.saveVitalSourceSetup(this.props.match.params.collId);
        }else if(this.state.currentComponent == 'CourseDetails'){
            this.props.saveCourseDetails(this.props.match.params.collId);
        }else if(this.state.currentComponent == 'offerDetails'){
            this.props.updateProductDetails(this.props.match.params.collId);
            this.props.updateOfferDetails(this.props.match.params.collId);
        }

        this.setFormDirty(false);
    }

    setActiveComponent(component){
        this.setState({
            currentComponent: component
        });
    }

    isPdfsBuilt(pdfLinks) {
        let isCoverBuilt = false;
        let isFullBookContentBuilt = false;
        let isIndexBuilt = false;
        let isFrontMatterBuild = false;

        if (pdfLinks.printContents) {
            pdfLinks.printContents.forEach(pdfLink => {
                if (pdfLink && pdfLink.contentUrl) {
                    if (pdfLink.printPageType === "Cover") {
                        isCoverBuilt = true;
                    }
                    if (pdfLink.printPageType === "Full Book Content") {
                        isFullBookContentBuilt = true;
                    }
                    if (pdfLink.printPageType === "Front Matter") {
                        isFrontMatterBuild = true;
                    }
                    if (pdfLink.printPageType === "Index") {
                        isIndexBuilt = true;
                    }
                }
            });
        }

        return (isCoverBuilt && isFullBookContentBuilt);
    }

    render() {
        const deliveryType = this.props.bookBuildContent.productDeliveryType;
        const isCollectionReady = this.props.activeCollection && Object.keys(this.props.activeCollection).length !== 0;
        const collId = this.props.match.params.collId;
        const rootPath = '/digital-book/'+ collId +'/';
        const pcsLogPath = `${rootPath}pcs-log`;
        let  bookDetailsPageRoutes = "";
        let isSalesRepUser = getSessionStorage('isSalesRepUser');
        let isLSAUser = getSessionStorage('isLSAUser');
        if (deliveryType == 'custometext' && isSalesRepUser == 'false'){
            bookDetailsPageRoutes = [
                {
                    path: rootPath.concat('book-details'),
                    component: BookDetailsLink,
                    title: 'Book Details',
                    options: {}
                },
                {
                    path: rootPath.concat('order-details'),
                    component: OrderDetailsLink,
                    title: 'Order Details',
                    options: {}
                },
                {
                    path: rootPath.concat('components'),
                    component: BookComponentTableLink ,
                    title: 'Components',
                    options: {}
                },
                {
                    path: rootPath.concat('access-code-setup'),
                    component: AccessCodeSetupLink,
                    title: 'Access Codes Set-up',
                    options: {}
                },
                {
                    path: rootPath.concat('etext-setup'),
                    component: ETextSetupLink,
                    title: 'EText Setup',
                    options: {}
                },
                {

                    path: rootPath.concat('product-offer-details'),
                    component: ProductOfferDetailsLink,
                    title: 'Product Offer Details',
                    options: {}

                },
                {
                    path: rootPath.concat('course-details'),
                    component: CourseDetailsLink,
                    title: 'Course Details',
                    options: {}
                },
            ];}

        else if (deliveryType == 'custometext' && isSalesRepUser == 'true'){
            bookDetailsPageRoutes = [
                {
                    path: rootPath.concat('book-details'),
                    component: BookDetailsLink,
                    title: 'Book Details',
                    options: {}
                },
                {
                    path: rootPath.concat('order-details'),
                    component: OrderDetailsLink,
                    title: 'Order Details',
                    options: {}
                },
                {
                    path: rootPath.concat('components'),
                    component: BookComponentTableLink ,
                    title: 'Components',
                    options: {}
                },
                {
                    path: rootPath.concat('access-code-setup'),
                    component: AccessCodeSetupLink,
                    title: 'Access Codes Set-up',
                    options: {}
                },
                {
                    path: rootPath.concat('etext-setup'),
                    component: ETextSetupLink,
                    title: 'EText Setup',
                    options: {}
                },
                {
                    path: rootPath.concat('course-details'),
                    component: CourseDetailsLink,
                    title: 'Course Details',
                    options: {}
                },
            ];}
        else
        {
            bookDetailsPageRoutes = [
                {
                    path: rootPath.concat('book-details'),
                    component: BookDetailsLink,
                    title: 'Book Details',
                    options: {}
                },
                {
                    path: rootPath.concat('order-details'),
                    component: OrderDetailsLink,
                    title: 'Order Details',
                    options: {}
                },
                {
                    path: rootPath.concat('components'),
                    component: BookComponentTableLink ,
                    title: 'Components',
                    options: {}
                },
                {
                    path: rootPath.concat('comp-code-setup'),
                    component: VitalSourceAccessCodeSetupLink,
                    title: 'Comp Code Set-up',
                    options: {}
                },
                {
                    path: rootPath.concat('vitalsource-setup'),
                    component: VitalSourceSetupLink,
                    title: 'VitalSource  Setup',
                    options: {}
                }
            ];
                
        }
        
        const {activeCollection } = this.props;
        const courseInformation = activeCollection.collectionCourseInformation ? activeCollection.collectionCourseInformation : {};
        const {etextStatuses} = this.props;
        const {vitalsourceStatuses} = this.props;

        const isSendToEtextDisabled = (etextStatuses['COURSE_CREATION'].indexOf("SUCCESS") > -1) || !this.isPdfsBuilt(this.props.pdfLinks) || isLSAUser === 'true';
        const isSendToVitalsourceDisabled = (vitalsourceStatuses['INVITE_EMAIL'].indexOf("SUCCESS") > -1) || !this.isPdfsBuilt(this.props.pdfLinks);
        return (

            isCollectionReady && <div className="book-container pe-row">
                <div className="pe-row">
                    <div className="pe-col-12">
                        <div className="book-alert">
                            <AlertBox/>
                        </div>
                    </div>
                </div>
                <div className="pe-row">
                    <div className="pe-col-12">
                    </div>
                </div>
                <div className="pe-row">
                    <div className="pe-col-12">
                        <label className="pe-page-title--small">{this.props.activeCollection.title ? this.props.activeCollection.title : '\u00A0'}</label>
                    </div>
                </div>
                <div className="info-row pe-row">
                    <div className="pe-col-2">
                        <p><strong>ISBN: </strong>{this.props.activeCollection.isbn}</p>
                        <p className="isbn13">{this.props.activeCollection.isbn13}</p>
                    </div>
                    <div className="pe-col-3">
                        {
                            (this.props.bookBuildContent.productDeliveryType === 'custometext') ?
                                <p>   <p><strong>Access Code ISBN: </strong>{this.props.activeCollection.accessCodeIsbn}</p>
                                    <p className="access-isbn13">{this.props.activeCollection.accessCodeIsbn13}</p> </p>: null
                             
                        }
                    </div>
                    <div className="pe-col-2"><p><strong>Estimated Enrollments: </strong>{courseInformation.estimatedQty}</p></div>
                    <div className="pe-col-5">
                        {
                            (this.props.collectionNotes && this.props.collectionNotes.holds && this.props.collectionNotes.holds.length > 0) && this.props.collectionNotes.holds.map((hold) =>{
                                return  <span className="tableBox orangeBox" >{hold}</span>;
                            })
                        }
                        {

                            (this.props.collectionNotes && this.props.collectionNotes.collectionNoteDTOS && this.props.collectionNotes.collectionNoteDTOS.length > 0) && <p className="note-summary">{Moment.utc(this.props.collectionNotes.collectionNoteDTOS[0].createdTimestamp).local().format("MM-DD-YYYY HH:mm:ss") + " ("}<EllipsisText text={this.props.collectionNotes.collectionNoteDTOS[0].body} length={25} />)</p>
                        }
                    </div>

                </div>
                <div className="pe-row">
                    <div className="pe-col-3 left-wrapper">
                        <BookNavigationPanel router={this.props.router} pageRoutes={bookDetailsPageRoutes}/>
                        <div className="book-build-button-wrapper">
                            {
                                (this.props.guardDirtyIsActive && (!UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_save_changes_button) || this.state.currentComponent === 'CourseDetails')) 
                                    ?  <button onClick={this.saveChanges} className="pe-btn__primary--btn_small">Save Changes</button>: <button onClick={this.saveChanges} disabled className="pe-btn__primary--btn_small">Save Changes</button>
                            }
                            { UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_send_to_pdh) ? <button onClick={this.sendToPCS} disabled className="send-to-pcs pe-btn__primary--btn_small">Send to PDH</button> : <button onClick={this.sendToPCS} className="send-to-pcs pe-btn__primary--btn_small">Send to PDH</button>}
                            <br/>
                            <div className="view-pcs-link">
                                { UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_view_pdf_log) ? <a> View PDH Log </a> : <Link  to={pcsLogPath}>View PDH Log</Link>}
                            </div><br/>
                            { (!this.props.activeCollection.hasPrivateResources) && (!UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_rebuild_book_button)) 
                                ? <button onClick={this.rebuildBook} className="send-to-pcs pe-btn__primary--btn_small">Rebuild Book</button> : <button disabled className="send-to-pcs pe-btn__primary--btn_small">Rebuild Book</button> }
                            <br/>
                            {
                                (this.props.bookBuildContent.productDeliveryType === 'custometext') ?
                                    (isSendToEtextDisabled || this.props.activeCollection.hasPrivateResources || UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_send_to_etext))  ?
                                        <button disabled className="send-to-pcs pe-btn__primary--btn_small">Send to eText</button> :
                                        <button onClick={this.sendToEtext} className="send-to-pcs pe-btn__primary--btn_small">Send to eText</button> :

                                    (isSendToVitalsourceDisabled || this.props.activeCollection.hasPrivateResources || UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_send_to_vitalsource)) ?
                                        <button disabled className="send-to-pcs pe-btn__primary--btn_small">Send to vitalsource</button> :
                                        <button onClick={this.sendToVitalsource} className="send-to-pcs pe-btn__primary--btn_small">Send to VitalSource </button>
                            }
                            <br/>

                        </div>
                        {
                            (this.props.activeCollection.collectionId) && <PdfLink collectionId={this.props.activeCollection.collectionId} getPdfsByCollectionId={this.props.getPdfsByCollectionId} pdfLinks={this.props.pdfLinks}/>
                        }

                    </div>
                    <div className="pe-col-9 right-wrapper">
                        <Switch>
                            {bookDetailsPageRoutes.map((route) => (<Route key={route.path} path={route.path} render={() => <route.component {...this.props} setComponent={this.setActiveComponent} options={route.options}/>}/>))}
                            <Route path={pcsLogPath} render={() => <PCSLogComponent logs={this.props.pcsLogs} getPCSLogs={()=>{this.props.getPCSLogs(collId);}}/>}/>
                            <Redirect to={rootPath + 'book-details'}/>
                        </Switch>
                    </div>
                </div>
                <Prompt
                    when={this.props.guardDirtyIsActive && !this.props.isModalOpen}
                    message="Changes you made may not be saved / There is unsaved data. Are you sure you want to leave this page?"
                />
                {this.props.children}
            </div>
        );
    }

}

export default guardDirtyState()(BookContainer);



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookContainer.js